import { upcaseFirst } from '@campaign-manager/core/lib/utils';

interface Props {
  text: string | undefined;
}

export default function UpcaseFirstLabel({ text }: Props) {
  return <>{upcaseFirst(text)}</>;
}
